<template>
    <div>
        <template v-if="!countdown.finished">
            <div class="sidebarBlock d-flex flex-wrap" id="countdown">
                <div class="iconBox">
                    <i class="icon-truck"></i>
                </div>
                <div class="text">
                    <div>{{ counttyp }}</div>
                    <div>{{ $translate("Servershop5::Template.todayAvailable") }}</div>
                    <div class="font-weight-bold">
                        <span v-html="countdown.hours"></span> {{ $translate("Servershop5::Template.hours") }}
                        <span v-html="countdown.minutes"></span> {{ $translate("Servershop5::Template.minutes") }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default
    {
        props: ['template', 'countdownTime',"counthour","countminute","counttyp"],
        data: function()
        {
            return {
                days:0,
                hours:0,
                minutes:0,
                seconds:0,
                finished:false
            };
        },
        mounted: function()
        {
            var _self = this;
            _self.createCountDown();
        },
        methods:
            {
                createCountDown: function ()
                {

                    var _self = this;
                    var countDownDate = new Date().setHours(this.counthour,this.countminute);

                    var x = setInterval(function()
                    {

                        // Get today's date and time
                        var now = new Date().getTime();

                        // Find the distance between now and the count down date
                        var distance = countDownDate - now;

                        // Time calculations for days, hours, minutes and seconds
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                        _self.days = days;
                        _self.hours = hours;
                        _self.minutes = minutes;
                        _self.seconds = seconds;

                        // If the count down is over, write some text
                        if (distance < 0)
                        {
                            clearInterval(x);
                            _self.finished = true
                        }
                    }, 1000);
                }
            },
        computed:
        {
            countdown: function ()
            {
                var _self = this;
                return {
                    days:_self.days,
                    hours:_self.hours,
                    minutes:_self.minutes,
                    seconds: _self.seconds,
                    finished: _self.finished
                };
            }
        }
    }
</script>
